import { list } from '@/services/banner.service'

const state = {
  bannerList: []
}

const actions = {
  getList ({ commit }, params = {}) {
    return list(params).then(res => {
      if (res.data.success) {
        commit('SET_LIST', res.data.data)
      }
    }).catch(err => {
      return err.response
    })
  }
}

const mutations = {
  SET_LIST (state, payload) {
    state.bannerList = payload
  }
}

const getters = {

}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
